import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {PearlHarborGameConfig} from "../PearlHarborGameConfig";
import {PearlHarbor} from "../PearlHarbor";
import {TweenLite} from "gsap";
import {PearlHarborHelper} from "../utils/PearlHarborHelper";

export class PearlHarborMainGameView extends PIXI.Container implements StageLayer {

    private _defaultSteps:number = 3;
    private _maxSteps:number = 7;
    private _zoomTime:number = 0.26;
    private _defaultZoom:number = 0.8;
    private _maxZoom:number = 1;

    private _overlayLayer:StageLayer | undefined;
    private _multLayer:StageLayer | undefined;
    private _scatterCounterLayer:StageLayer | undefined;
    private _boostBetLayer:StageLayer | undefined;
    private _frameLayer:StageLayer;

    constructor() {
        super();
        this.name = "MAIN_GAME";
        this.init();
        this.onResize();
    }

    private addFrames():void {
        const frameLeft:PIXI.Sprite = new PIXI.Sprite(PearlHarbor.assetLoader.getTextures("Frame/frameSide")[0]);
        const frameRight:PIXI.Sprite = new PIXI.Sprite(PearlHarbor.assetLoader.getTextures("Frame/frameSide")[0]);
        const frameTopLeft:PIXI.Sprite = new PIXI.Sprite(PearlHarbor.assetLoader.getTextures("Frame/frameTopBotom")[0]);
        const frameBottomLeft:PIXI.Sprite = new PIXI.Sprite(PearlHarbor.assetLoader.getTextures("Frame/frameTopBotom")[0]);
        const frameTopRight:PIXI.Sprite = new PIXI.Sprite(PearlHarbor.assetLoader.getTextures("Frame/frameTopBotom")[0]);
        const frameBottomRight:PIXI.Sprite = new PIXI.Sprite(PearlHarbor.assetLoader.getTextures("Frame/frameTopBotom")[0]);
        frameRight.name = "frameRight";
        frameLeft.name = "frameLeft";
        frameTopLeft.name = "frameTopLeft";
        frameTopRight.name = "frameTopRight";
        frameBottomLeft.name = "frameBottomLeft";
        frameBottomRight.name = "frameBottomRight";
        frameRight.anchor.set(1, 0);
        frameLeft.anchor.set(0, 0);
        frameTopLeft.anchor.set(1, 1);
        frameTopRight.anchor.set(0, 1);
        frameBottomLeft.anchor.set(1, 0);
        frameBottomRight.anchor.set(0, 0);
        frameRight.scale.set(-1, 1);
        frameTopLeft.scale.set(1, 1);
        frameTopRight.scale.set(-1, 1);
        frameBottomLeft.scale.set(1, -1);
        frameBottomRight.scale.set(-1, -1);
        frameRight.position.set(800, 22);
        frameLeft.position.set(-99, 22);
        frameTopLeft.position.set(360, 25);
        frameTopRight.position.set(1047, 25);
        frameBottomLeft.position.set(360, 784);
        frameBottomRight.position.set(1047, 784);
        this._frameLayer.addChild(frameLeft);
        this._frameLayer.addChild(frameRight);
        this._frameLayer.addChild(frameBottomLeft);
        this._frameLayer.addChild(frameBottomRight);
        this._frameLayer.addChild(frameTopLeft);
        this._frameLayer.addChild(frameTopRight);
    }

    private init():void {
        this._frameLayer = NolimitApplication.getLayerByName(PearlHarborGameConfig.LAYERS.MAINGAME_FRAME)!;
        this._overlayLayer = NolimitApplication.getLayerByName(PearlHarborGameConfig.LAYERS.OVERLAY);
        this._boostBetLayer = NolimitApplication.getLayerByName(PearlHarborGameConfig.LAYERS.BOOST_BET);
        this._multLayer = NolimitApplication.getLayerByName(PearlHarborGameConfig.LAYERS.MULTIPLIER);
        this._scatterCounterLayer = NolimitApplication.getLayerByName(PearlHarborGameConfig.LAYERS.SCATTER_COUNTER);

        //this.createReelBlurBg();
        this.addFrames();
        this.addChild(PearlHarbor.allReelsView);
        this.addChild(PearlHarbor.activeSymbolsBackground);
        this.addChild(this._frameLayer);
        this.addChild(PearlHarbor.scatterCounter);
        this._boostBetLayer && this.addChild(this._boostBetLayer);
        this._multLayer && this.addChild(this._multLayer);
        this._scatterCounterLayer && this.addChild(this._scatterCounterLayer);
        this._overlayLayer && this.addChild(this._overlayLayer);
        this.addChild(PearlHarbor.activeSymbolsBackground.crosshair);

        this.resetZoom();
    }

    private adjustLayerComponents(noDelay:boolean = false):void {
        const rePosTime:number = noDelay ? 0 : this._zoomTime;
        this.adjustWaysLayer(rePosTime);
        this.adjustMultLayer(rePosTime);
        this.adjustScatterCounterLayer(rePosTime);
    }

    private adjustWaysLayer(rePosTime:number):void {
        const isLandscape:boolean = NolimitApplication.isLandscape,
            isIpad:boolean = PearlHarborHelper.isIpad;

        if(this._boostBetLayer) {
            let waysLayerPos:number[];

            if(isIpad) {
                if(isLandscape) {
                    waysLayerPos = [-120, 116];
                } else {
                    waysLayerPos = [14, -11];
                }
            } else {
                if(isLandscape) {
                    waysLayerPos = [-120, 116];
                } else {
                    waysLayerPos = [14, -11];
                }
            }

            TweenLite.to(this._boostBetLayer.position, rePosTime, {
                x : waysLayerPos[0], y : waysLayerPos[1]
            });
        }
    }

    private adjustMultLayer(rePosTime:number):void {
        const isLandscape:boolean = NolimitApplication.isLandscape,
            isIpad:boolean = PearlHarborHelper.isIpad;

        if(this._multLayer) {
            let multLayerPos:number[];

            if(isIpad) {
                if(isLandscape) {
                    multLayerPos = [925, 410];
                } else {
                    multLayerPos = [820, 65];
                }
            } else {
                if(isLandscape) {
                    multLayerPos = [925, 410];
                } else {
                    multLayerPos = [820, 65];
                }
            }

            TweenLite.to(this._multLayer.position, rePosTime, {
                x : multLayerPos[0], y : multLayerPos[1]
            });
        }
    }

    private adjustScatterCounterLayer(rePosTime:number):void {
        const isLandscape:boolean = NolimitApplication.isLandscape,
            isIpad:boolean = PearlHarborHelper.isIpad;
        if(this._scatterCounterLayer) {
            let multLayerPos:number[];

            if(isIpad) {
                if(isLandscape) {
                    multLayerPos = [872, 113];
                } else {
                    multLayerPos = [367, 55];
                }
            } else {
                if(isLandscape) {
                    multLayerPos = [872, 113];
                } else {
                    multLayerPos = [367, 55];
                }
            }

            TweenLite.to(this._scatterCounterLayer.position, rePosTime, {
                x : multLayerPos[0], y : multLayerPos[1]
            });
        }
    }

    public hideRedBG():TweenLite {
        return TweenLite.to(this, 0.1, {alpha : 1});
        //return TweenLite.to(this._redBGGlow, 0.2, {alpha: 0, onComplete: () => {this._redBGGlow.visible = false}});
    }

    public onResize():void {
        const isLandscape:boolean = NolimitApplication.isLandscape,
            isIpad:boolean = PearlHarborHelper.isIpad;
        this.adjustLayerComponents(true);
        PearlHarbor.scatterCounter.adjustComponents();
        if(isLandscape) {
            this.applyZoom(isIpad?this._maxSteps:this._defaultSteps);
        } else {
            this.applyZoom(this._maxSteps);
        }
    }

    public resetZoom():void {
        this.applyZoom(this._defaultSteps);
    }

    public hideOnFSIntro():void {
        this.visible = false;
    }

    public showOnFSOutro():void {
        PearlHarbor.multiplier.showLayer();
        PearlHarbor.scatterCounter.showLayer();
        this.visible = true;
    }

    public applyZoom(steps:number, isFromFSIntro:boolean = false):void {
        let zoomTime:number = isFromFSIntro ? 0 : this._zoomTime;
        const symbolAnimationLayer:PIXI.Container = NolimitApplication.getLayerByName("XSplitAnimation")!,
            clusterWinNumberLayer:PIXI.Container = NolimitApplication.getLayerByName("PearlHarborInitialWinView")!;
        if(steps === this._maxSteps) {
            TweenLite.to(this.position, zoomTime, {
                x : 14, y : 0
            });
            TweenLite.to(this._frameLayer.position, zoomTime, {
                x : 68, y : 88
            });
            TweenLite.to(clusterWinNumberLayer.position, zoomTime, {
                x : 68, y : 72
            });
            TweenLite.to(clusterWinNumberLayer.scale, zoomTime, {
                x : this._defaultZoom, y : this._defaultZoom
            });
            TweenLite.to(symbolAnimationLayer, zoomTime, {
                x : 59, y : 91
            });
            TweenLite.to(symbolAnimationLayer.scale, zoomTime, {
                x : this._defaultZoom, y : this._defaultZoom
            });
            TweenLite.to(this.scale, zoomTime, {
                x : this._defaultZoom, y : this._defaultZoom
            });
        } else {
            TweenLite.to(this.position, zoomTime, {
                x : -69, y : -90
            });
            TweenLite.to(this._frameLayer.position, zoomTime, {
                x : 69, y : 90
            });
            TweenLite.to(clusterWinNumberLayer.position, zoomTime, {
                x : 0, y : 0
            });
            TweenLite.to(clusterWinNumberLayer.scale, zoomTime, {
                x : this._maxZoom, y : this._maxZoom
            });
            TweenLite.to(symbolAnimationLayer, zoomTime, {
                x : -12, y : 24
            });
            TweenLite.to(symbolAnimationLayer.scale, zoomTime, {
                x : this._maxZoom, y : this._maxZoom
            });
            TweenLite.to(this.scale, zoomTime, {
                x : this._maxZoom, y : this._maxZoom
            });
        }
    }
}